/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LastPlacedOrderDetailsQueryVariables = Types.Exact<{
  input: Types.OrdersInput;
}>;

export type LastPlacedOrderDetailsQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly isOutpost: boolean;
          };
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
          } | null;
        }>;
      }
    | { readonly __typename?: 'ValidationError' };
};

export const lastPlacedOrderDetailsQueryMock: ExecutionResult<LastPlacedOrderDetailsQuery> =
  {
    data: {
      orders: {
        __typename: 'OrdersResponseSuccess',
        orders: [
          {
            id: '509e6ea9-fee4-42a9-9625-87ce71904308',
            orderType: 'DELIVERY',
            restaurant: {
              id: 'da7a7163-ba7e-4da9-ae8a-185e3da00a9a',
              name: 'Hello World',
              isOutpost: false,
            },
            deliveryOrderDetail: { id: '7534319d-0806-40b5-9aa2-50f9c4016b1b' },
          },
          {
            id: 'd634cb27-3b7f-49f1-8d03-0f1b1f2c49f5',
            orderType: 'DELIVERY',
            restaurant: {
              id: 'fd7994cc-dcab-438b-b485-afbe88532ede',
              name: 'Hello World',
              isOutpost: false,
            },
            deliveryOrderDetail: { id: 'a1daa933-e0e0-495a-bb48-f0bb560d0180' },
          },
          {
            id: 'd39ca0c0-520a-4352-a4a6-541b5bc5d089',
            orderType: 'DELIVERY',
            restaurant: {
              id: 'f52e921d-91bf-4dfb-abd3-8fdf8eb15058',
              name: 'Hello World',
              isOutpost: false,
            },
            deliveryOrderDetail: { id: 'b384c482-99be-4511-b9b1-e39b6d74afbe' },
          },
        ],
      },
    },
  };

export const LastPlacedOrderDetailsDocument = gql`
  query LastPlacedOrderDetails($input: OrdersInput!) {
    orders(input: $input) {
      ... on OrdersResponseSuccess {
        __typename
        orders {
          id
          orderType
          restaurant {
            id
            name
            isOutpost
          }
          deliveryOrderDetail {
            id
          }
        }
      }
    }
  }
`;

export function useLastPlacedOrderDetailsQuery(
  options: Omit<
    Urql.UseQueryArgs<LastPlacedOrderDetailsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    LastPlacedOrderDetailsQuery,
    LastPlacedOrderDetailsQueryVariables
  >({ query: LastPlacedOrderDetailsDocument, ...options });
}
